import React from 'react'
import Content from './Content';


const CommsDetail = () => (
  <div className="container notification-center">
    <div className="well ssp-well px-5">
      <Content />
    </div>
  </div>
)

CommsDetail.propTypes = {
};

CommsDetail.defaultProps = {};
export default CommsDetail
